<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}{{ query.categoryName }}信息</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增维修申请</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
      <el-tabs v-model="query.category" @tab-click="handleClick" stretch>
        <el-tab-pane v-for="item in FaultRepairOptions" :key="item.id" :name="item.id">
          <template slot="label">
            <span style="margin: 0 10px"> {{ item.name }} </span>
          </template>
        </el-tab-pane>
      </el-tabs>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <template v-for="(item, index) in tableColumn">
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" :min-width="item.minWidth" v-if="item.type == 'ware'">
            <template slot-scope="scope">
              <template v-if="item.formatter">
                <div>
                  {{ item.formatter(scope.row[item.rowData.data1]) }}
                </div>
                <div>
                  {{ item.formatter(scope.row[item.rowData.data2]) }}
                </div>
              </template>
              <template v-else>
                <div>
                  {{ scope.row[item.rowData.data1] }}
                </div>
                <div>
                  {{ scope.row[item.rowData.data2] }}
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column :key="index" label="资产卡号" align="center" width="200" v-else-if="item.type == 'AssetCard'">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
                <div slot="content" class="">
                  <div class="tooltip-text" v-for="i in scope.row.assetCardInfos" :key="i.id">
                    {{ i.no }}
                  </div>
                </div>
                <span class="td-overflow-hidden">{{
                  scope.row.assetCardInfos
                    ? scope.row.assetCardInfos.map((e) => e.no).join(";")
                    : ""
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- 日期 -->
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" v-else-if="item.type == 'Date'">
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{y}-{m}-{d}") }}
              </div>
            </template>
          </el-table-column>
          <!-- 时间 -->
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" v-else-if="item.type == 'DateTime'">
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{y}-{m}-{d}") }}
              </div>
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{h}:{i}:{s}") }}
              </div>
            </template>
          </el-table-column>
          <!-- 普通列 -->
          <el-table-column v-else :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width"></el-table-column>
        </template>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames" />
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="进度" width="120" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" :width="operationWidth">
          <template slot-scope="scope">
            <div style="white-space:nowrap;">
              <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
              <el-button v-if="
                  scope.row.status != 1 &&
                    tableAcl.indexOf('Edit') != -1 &&
                    canEdit(scope.row)
                " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
              <el-button v-if="tableAcl.indexOf('Remove') != -1 && canDelete(scope.row)" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              <el-button v-if="
                  scope.row.responseState == 1 &&
                    tableAcl.indexOf('Edit') != -1 &&
                    query.category == '1'
                " type="text" v-preventReClick @click="handleResponse(scope.row)" class="margin-left20 color-blue">响应</el-button>
              <el-button v-if="
                  scope.row.status != 1 &&
                    tableAcl.indexOf('Edit') != -1 &&
                    query.category == '2' &&
                    scope.row.repairState == 1
                " type="text" v-preventReClick @click="handleReceiving(scope.row)" class="margin-left20 color-blue">接单</el-button>
              <el-button v-if="
                  scope.row.status != 1 &&
                    tableAcl.indexOf('Edit') != -1 &&
                    query.category == '2' &&
                    scope.row.repairState == 1
                " type="text" v-preventReClick @click="handleIgnore(scope.row)" class="margin-left20 color-blue">忽略</el-button>
              <el-button v-if="
                  scope.row.state == 0 &&
                    tableAcl.indexOf('Edit') != -1 &&
                    query.category == '3'
                " type="text" v-preventReClick @click="handleCheck(scope.row)" class="margin-left20 color-blue">验收</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { RemoveRepairApplys, GetRepairApplys } from "@/api"; //维修申请
import { RemoveRepairResponses, GetRepairResponses } from "@/api"; //维修响应
import {
  RemoveAcceptRepairOrders,
  GetAcceptRepairOrders,
  AcceptOrIgnoreAcceptRepairOrder,
} from "@/api"; //下级接单
import { RemoveHospitalChecks, GetHospitalChecks } from "@/api"; //院内验收
import GetDataMixin from "@/mixin/getData-mixin.js";
import { FaultRepairOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
// import Info from './info';

export default {
  mixins: [GetDataMixin],
  components: {
    // Info
    SelectFilter,
  },
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "0",
        categoryName: "维修申请",
      },
      tableColumn: [],
      tableColumn1: [
        {
          label: "维修单号",
          prop: "no",
          width: "180",
        },
        {
          type: "ware",
          label: "资产名称",
          rowData: {
            data1: "fixedAssetName",
            data2: "fixedAssetNo",
          },
          minWidth: "180",
        },
        {
          type: "AssetCard",
        },
        {
          label: "单价",
          prop: "price",
          width: "80",
          formatter: this.toDecimal4,
        },
        {
          label: "资产类型",
          prop: "assetTypeName",
          width: "100",
          align: "center",
        },
        {
          label: "规格型号",
          prop: "specName",
          width: "100",
          tooltip: true,
        },
        {
          label: "紧急程度",
          prop: "urgentLevelName",
          width: "100",
          align: "center",
        },
        {
          label: "故障问题",
          prop: "faultProblemName",
          width: "140",
          align: "center",
          formatter: this.getProblemName,
          tooltip: true,
        },
        {
          type: "Date",
          label: "期望修复日期",
          prop: "repairDate",
          width: "120",
        },
        {
          label: "备注",
          prop: "remark",
          width: "140",
          tooltip: true,
        },
        {
          label: "响应状态",
          prop: "responseStateName",
          width: "100",
          align: "center",
        },
        {
          label: "维修状态",
          prop: "repairStateName",
          width: "100",
          align: "center",
        },
      ],
      tableColumn2: [
        {
          label: "维修单号",
          prop: "repairApplyNo",
          width: "180",
        },
        {
          type: "ware",
          label: "资产名称",
          rowData: {
            data1: "fixedAssetName",
            data2: "fixedAssetNo",
          },
          minWidth: "180",
        },
        {
          type: "AssetCard",
        },
        {
          label: "单价",
          prop: "price",
          width: "80",
          formatter: this.toDecimal4,
        },
        {
          label: "资产类型",
          prop: "assetTypeName",
          width: "100",
          align: "center",
        },
        {
          label: "规格型号",
          prop: "specName",
          width: "100",
          tooltip: true,
        },
        {
          label: "紧急程度",
          prop: "urgentLevelName",
          width: "100",
          align: "center",
        },
        {
          label: "故障问题",
          prop: "faultProblemName",
          width: "140",
          align: "center",
          formatter: this.getProblemName,
          tooltip: true,
        },
        {
          type: "Date",
          label: "期望修复日期",
          prop: "repairDate",
          width: "120",
        },
        {
          label: "故障说明",
          prop: "repairDesc",
          width: "140",
          tooltip: true,
        },
        {
          label: "响应状态",
          prop: "responseStateName",
          width: "100",
          align: "center",
        },
        {
          label: "维修状态",
          prop: "repairStateName",
          width: "100",
          align: "center",
        },
      ],
      tableColumn3: [
        {
          label: "维修单号",
          prop: "repairApplyNo",
          width: "180",
        },
        {
          type: "ware",
          label: "资产名称",
          rowData: {
            data1: "fixedAssetName",
            data2: "fixedAssetNo",
          },
          minWidth: "180",
        },
        {
          type: "AssetCard",
        },
        {
          label: "单价",
          prop: "price",
          width: "80",
          formatter: this.toDecimal4,
        },
        {
          label: "资产类型",
          prop: "assetTypeName",
          width: "100",
          align: "center",
        },
        {
          label: "规格型号",
          prop: "specName",
          width: "100",
          tooltip: true,
        },
        {
          label: "紧急程度",
          prop: "urgentLevelName",
          width: "100",
          align: "center",
        },
        {
          label: "故障问题",
          prop: "faultProblemName",
          width: "140",
          align: "center",
          formatter: this.getProblemName,
          tooltip: true,
        },
        {
          type: "Date",
          label: "期望修复日期",
          prop: "repairDate",
          width: "120",
        },
        {
          label: "响应说明",
          prop: "repairDesc",
          width: "140",
          tooltip: true,
        },
        {
          label: "维修状态",
          prop: "repairStateName",
          width: "100",
          align: "center",
        },
      ],
      tableColumn4: [
        {
          label: "维修单号",
          prop: "repairApplyNo",
          width: "180",
        },
        {
          type: "ware",
          label: "资产名称",
          rowData: {
            data1: "fixedAssetName",
            data2: "fixedAssetNo",
          },
          minWidth: "180",
        },
        {
          type: "AssetCard",
        },
        {
          label: "单价",
          prop: "price",
          width: "80",
          formatter: this.toDecimal4,
        },
        {
          label: "资产类型",
          prop: "assetTypeName",
          width: "100",
          align: "center",
        },
        {
          label: "规格型号",
          prop: "specName",
          width: "100",
          tooltip: true,
        },
        {
          label: "紧急程度",
          prop: "urgentLevelName",
          width: "100",
          align: "center",
        },
        {
          label: "故障问题",
          prop: "faultProblemName",
          width: "140",
          align: "center",
          formatter: this.getProblemName,
          tooltip: true,
        },
        {
          type: "Date",
          label: "期望修复日期",
          prop: "repairDate",
          width: "120",
          formatter: this.DateFomatter,
        },
        {
          type: "Date",
          label: "实际修复时间",
          prop: "repairDate",
          width: "120",
        },
        {
          label: "验收状态",
          prop: "stateName",
          width: "100",
          align: "center",
        },
      ],
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      FaultRepairOptions: FaultRepairOptions,
      filterOptions: [
        {
          name: "使用科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "使用库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "资产编号",
          type: "select",
          code: "assetId",
          filterMethod: this.getFixedAssets,
          data: [],
        },
        {
          name: "资产类型",
          type: "selectTree",
          code: "assetTypeId",
          filterMethod: this.getFixedAssetTrees,
          data: [],
          defaultProps: {
            children: "children",
            label: "name",
          },
          text: "",
        },
        {
          name: "紧急程度",
          type: "select",
          code: "urgentLevelId",
          filterMethod: this.getDegreeStatus,
          data: [],
        },
        {
          name: "故障问题",
          type: "selectTree",
          code: "faultProblemId",
          filterMethod: this.getFaultProblemTrees,
          data: [],
          defaultProps: {
            children: "children",
            label: "name",
          },
          text: "",
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
      ],
      operationWidth: 140,
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    refenceQuery () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "0",
        categoryName: "维修申请",
      };
      this.tableColumn = this.tableColumn1;
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
    },
    // 获取列表
    getData () {
      switch (this.query.category) {
        case "0":
          GetRepairApplys({
            keyWord: this.query.keyWord,
            pageSize: this.query.pageSize,
            pageIndex: this.query.pageIndex,
          }).then((res) => {
            this.tableData = res.returnData.data;
            this.total = res.returnData.totalCount;
          });
          break;
        case "1":
          GetRepairResponses({
            keyWord: this.query.keyWord,
            pageSize: this.query.pageSize,
            pageIndex: this.query.pageIndex,
          }).then((res) => {
            this.tableData = res.returnData.data;
            this.total = res.returnData.totalCount;
          });
          break;
        case "2":
          GetAcceptRepairOrders({
            keyWord: this.query.keyWord,
            pageSize: this.query.pageSize,
            pageIndex: this.query.pageIndex,
          }).then((res) => {
            this.tableData = res.returnData.data;
            this.total = res.returnData.totalCount;
          });
          break;
        case "3":
          GetHospitalChecks({
            keyWord: this.query.keyWord,
            pageSize: this.query.pageSize,
            pageIndex: this.query.pageIndex,
          }).then((res) => {
            this.tableData = res.returnData.data;
            this.total = res.returnData.totalCount;
          });
          break;
      }
    },
    // 新建
    handleAdd () {
      this.$router.push("/fault-repair-edit?formMode=1");
    },
    // 查看信息
    handleInfo (row) {
      switch (this.query.category) {
        case "0":
          //申请
          this.$router.push("/fault-repair-edit?formMode=0&id=" + row.id);
          break;
        case "1":
          //响应
          this.$router.push(
            "/fault-repair-edit?formMode=0&id=" + row.id + "&operation=0"
          );
          break;
        case "2":
          //接单
          this.$router.push(
            "/fault-repair-edit?formMode=0&id=" + row.id + "&operation=1"
          );
          break;
        case "3":
          //验收

          this.$router.push(
            "/fault-repair-edit?formMode=0&id=" + row.id + "&operation=4"
          );
          break;
      }
    },
    // 编辑
    handleUpdate (row) {
      if (this.query.category == "0") {
        this.$router.push("/fault-repair-edit?formMode=2&id=" + row.id); //编辑
      } else {
        this.$router.push(
          "/fault-repair-edit?formMode=4&id=" + row.id + "&operation=2"
        ); //接单编辑
      }
    },
    // 审批
    handleApprove (row) {
      this.$router.push("/fault-repair-edit?formMode=3&id=" + row.id);
    },
    // 响应
    handleResponse (row) {
      this.$router.push(
        "/fault-repair-edit?formMode=4&id=" + row.id + "&operation=0"
      );
    },
    // 接单
    handleReceiving (row) {
      AcceptOrIgnoreAcceptRepairOrder({
        acceptOrIgnore: 1,
        repairApplyId: row.repairApplyId,
        id: row.id,
      }).then((res) => {
        this.$my_message(`操作成功！`, "success");
        this.getData();
      });
      // this.$router.push(
      //   "/fault-repair-edit?formMode=4&id=" + row.id + "&operation=1"
      // );
    },
    // 忽略
    handleIgnore (row) {
      AcceptOrIgnoreAcceptRepairOrder({
        acceptOrIgnore: 0,
        repairApplyId: row.repairApplyId,
        id: row.id,
      }).then((res) => {
        this.$my_message(`操作成功！`, "success");
        this.getData();
      });
      // this.$router.push(
      //   "/fault-repair-edit?formMode=4&id=" + row.id + "&operation=3"
      // );
    },
    // 验收
    handleCheck (row) {
      this.$router.push(
        "/fault-repair-edit?formMode=4&id=" + row.id + "&operation=4"
      );
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          switch (this.query.category) {
            case "0":
              return RemoveRepairApplys({ ids });
            case "1":
              return RemoveRepairResponses({ ids });
            case "2":
              return RemoveAcceptRepairOrders({ ids });
            case "3":
              return RemoveHospitalChecks({ ids });
          }
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "0",
        categoryName: "维修申请",
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    handleClick (tab) {
      // this.query.type =
      let item = this.FaultRepairOptions.find((e) => e.id == tab.name);
      if (item) {
        this.query.categoryName = item.name;
      }
      switch (tab.index) {
        case "0":
          this.tableColumn = this.tableColumn1;
          this.operationWidth = 130;
          break;
        case "1":
          this.tableColumn = this.tableColumn2;
          this.operationWidth = 130;
          break;
        case "2":
          this.tableColumn = this.tableColumn3;
          this.operationWidth = 140;
          break;
        case "3":
          this.tableColumn = this.tableColumn4;
          this.operationWidth = 140;
          break;
      }
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    canEdit (row) {
      if (this.query.category == "0") {
        // 维修申请
        if (row.responseState == 1) {
          // 待响应
          return true;
        } else {
          return false;
        }
      } else if (this.query.category == "2") {
        // 下级接单
        if (row.repairState == 2) {
          //维修中
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    canDelete (row) {
      if (this.query.category == 0) {
        // 维修申请
        if (row.responseState == 1) {
          //待响应
          return true;
        } else if (row.responseState == 0) {
          //已忽略
          if (this.userInfo.id == row.createdUser || this.isAdmin) {
            //是发起人/管理员
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getProblemName (row, column, cellValue, index) {
      return row.faultProblemInfos.map((item) => item.name).join(",");
    },
  },
  mounted () { },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.tableColumn = this.tableColumn1;
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 500px;
  margin-bottom: 10px;
}
</style>
